var _excluded = ["property", "editable", "editRenderer", "type"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Table, Form } from "../..";
import AdvancedTableEditingCell from "./AdvancedTableEditingCell";

/**
 * Format date to display in format dd/mm/yyyy
 *
 * @param {*} date
 * @return {*}
 */
import { jsx as _jsx } from "react/jsx-runtime";
var formatDate = function formatDate(date) {
  if (_.isString(date) && _.isEmpty(date)) {
    return date;
  }
  var calendarDate = new Date(date);
  return calendarDate.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};
var AdvancedTableCell = function AdvancedTableCell(props) {
  var column = props.column,
    item = props.item,
    selected = props.selected,
    value = props.value,
    onChange = props.onChange,
    onClick = props.onClick,
    onBlur = props.onBlur;
  var property = column.property,
    editable = column.editable,
    editRenderer = column.editRenderer,
    type = column.type,
    restUnfiltered = _objectWithoutPropertiesLoose(column, _excluded);
  var rest = _.omit(restUnfiltered, ['text', 'sortable']);
  var handleClick = React.useCallback(function () {
    if (onClick) {
      onClick(item, column);
    }
  }, [onClick, item, column]);
  var handleCheckboxChange = React.useCallback(function (e, _ref) {
    var checked = _ref.checked;
    if (onChange) {
      onChange(item, column.property, checked);
    }
  }, [column.property, item, onChange]);

  // si on a sélectionné une cellule modifiable
  if (selected && editable) {
    return /*#__PURE__*/_jsx(AdvancedTableEditingCell, {
      column: column,
      onChange: onChange,
      value: value,
      item: item,
      onBlur: onBlur,
      onClick: handleClick
    });
  }
  return (
    // si ce n'est pas une checkbox on affiche la cell
    type !== 'checkbox' ? /*#__PURE__*/_jsx(Table.Cell, Object.assign({
      onClick: handleClick,
      style: {
        cursor: editable ? 'pointer' : 'default'
      }
    }, rest, {
      children: type === 'date' ? formatDate(item[property]) : item[property]
    })) : /*#__PURE__*/_jsx(Table.Cell, Object.assign({
      textAlign: "center",
      style: {
        padding: 0
      }
    }, rest, {
      children: /*#__PURE__*/_jsx(Form.Checkbox, {
        checked: item[property],
        onChange: handleCheckboxChange
      })
    }))
  );
};
AdvancedTableCell.handledProps = ["column", "item", "onBlur", "onChange", "onClick", "selected", "value"];
AdvancedTableCell.propTypes = {
  /**
     * Définition de la colonne
     */
  column: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /**
     * Element de la ligne
     */
  item: PropTypes.object,
  // eslint-disable-line react/forbid-prop-types

  /**
     * La cellule est sélectionnée
     */
  selected: PropTypes.bool,
  /**
     * La valeur de la cellule en modification
     */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
     * Callback au clic sur la cellule
     */
  onClick: PropTypes.func,
  /**
     * Callback au changement de l'input
     */
  onChange: PropTypes.func,
  /**
     * Callback au blur de l'input
     */
  onBlur: PropTypes.func
};
AdvancedTableCell.defaultProps = {
  column: {},
  item: {},
  selected: false,
  value: undefined,
  onClick: null,
  onChange: null,
  onBlur: null
};
export default AdvancedTableCell;